module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0005-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('em', [_vm._v("Dedicated to my mom and dad, for always encouraging me to pursue my passions, even when they’re made of ice")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('em', [_vm._v("And of course, to Drew—none of this would exist without you")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23768659","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03dedication.vue
// module id = 63
// module chunks = 0